import MyButton from "components/MyButton";
import Tabs from "components/Tabs";
import { SubHeader } from "layout/SubHeader";
import React, { useState } from "react";
import ArrowDSVG from "../../../assets/icons/svg/arrow-details";
import AddParticipant from "./AddParticipant";
import { useHistory } from "react-router-dom";
import "./index.scss";
import ParticipantsTable from "./ParticipantsTable";

const Participants = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [form, setForm] = useState({});
  const [show, setShow] = useState("table");
  const history = useHistory();
  const idLength = history.location.pathname?.split("/").length;
  const classId = history?.location?.pathname?.split("/")[idLength - 1];
  return (
    <div className="school-classes pr-10 pt-5">
      <div className="header">
        <div className="header-tittle">
          <ArrowDSVG
            style={{ cursor: "pointer" }}
            onClick={() =>
              show === "table"
                ? history.push("/religious-schools")
                : setShow("table")
            }
          />
          <SubHeader
            className="subheader"
            {...{
              title: "Religious school",
            }}
          />
          <SubHeader
            className="class-tab subheader"
            {...{
              title: "-Participants",
            }}
          />
        </div>
        <div className="new-class">
          <MyButton
            type={"primary"}
            content={"Add Participant"}
            onClick={() => setShow("add")}
            // onClick={() => {}}
          />
        </div>
      </div>
      {show === "add" ? (
        <AddParticipant form={form} />
      ) : (
        <div>
          <Tabs
            tabs={[
              {
                title: "All",
                content: <ParticipantsTable member={""} setForm={setForm} />,
              },
              // {
              //   title: "Member",
              //   content: <ParticipantsTable member={"/member"} />,
              // },
              // {
              //   title: "Not Member",
              //   content: <ParticipantsTable member={"/nonmember"} />,
              // },
            ]}
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            type="secondary"
          ></Tabs>
        </div>
      )}
    </div>
  );
};
export default Participants;
